import Swal from "sweetalert2";
import { queryClient } from "../../..";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function deleteMovimento(id: number) {
  return await api
    .delete(`${URLS.MOVIMENTOS_API}/${id}`)
    .then((response) => {
      console.log(response);
      Swal.fire({
        title: "Movimento Excluído",
        text: "O movimento foi excluído com sucesso!",
        icon: "success",
        position: "center",
        confirmButtonText: "OK",
        confirmButtonColor: "#349946",
        allowOutsideClick: false
      });
      queryClient.invalidateQueries();
      return response.status
    })
    .catch((err) => {
      if (err.response.status === 500) {
        Swal.fire({
          title: "Erro ao deletar o movimento",
          text: `O movimento não pode ser excluído. Verifique se o mesmo possuí algum vínculo e tente novamente`,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: '#F27474',
          allowOutsideClick: false
        });

      }
      if(err.response.status === 400){
        Swal.fire({
          title: 'Erro ao excluir movimento',
          text: err.response.data.message,
          icon: 'error',
          position: 'center',
          confirmButtonText: 'OK',
          confirmButtonColor: '#F27474',
          allowOutsideClick: false
        })
        
      }
    });
}
